
export const RENEW_ROUTE = '/pricing';

export interface SubscriptionStatusData {
  hasSubscription?: boolean;
  isExpired?: boolean;
  isExpiringSoon?: boolean;
  status?: string;
  planName?: string;
  daysRemaining?: number | null;
  endDate?: string;
}

export interface SubscriptionStatusState {
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  data?: SubscriptionStatusData | null;
}


export const isSubscriptionExpired = (
  status: SubscriptionStatusState | undefined,
  role: string | undefined,
): boolean => {
  if (role === 'SUPER_ADMIN') return false;
  if (!status?.isSuccess || !status?.data) return false;
  const { isExpired, hasSubscription } = status.data;
  return isExpired === true || hasSubscription === false;
};
